/* eslint-disable */
import React from 'react'
import http from '../../Component/Interceptor/Interseptor'
import $ from 'jquery'
import {accounting} from 'accounting'
import jMoment from 'moment-jalaali'
import {Link} from 'react-router-dom'
import cookie from 'react-cookies'
import REPORT_RETAIL from '../BaseComponent/REPORTRETAIL'
import HeaderTablePrint from '../BaseComponent/HeaderTablePrint'
import {ExcelExport, grid, gridColumn, ExcelExportColumn} from '@progress/kendo-react-excel-export'

import SearchCustomer from '../BaseComponent/SearchCustomer'
import HeaderGrid from '../Pagination/HeaderGrid'
import Sort from '../Pagination/Sort'
import Pageing from '../Pagination/pageing'
import Loader from '../loaders/loader'
import {voip} from './call/voip'
import {message} from 'antd'
import {Modal, ModalBody} from 'mdbreact'
import FromToPicker from '../BaseComponent/FromToPicker'

class RfmlReport extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: false,
      printInfo: [],
      pageNumber: 1,
      pageSize: 100,
      countAll: 0,
      buttonClicked: false,
      rfml: [],
      fromDate: '',
      toDate: '',
      sortBy: 'purchaseCount_desc',
      fromPrintDate: '',
      toPrintDate: '',
      customerCode: '',
      sortData: [
        {
          name: 'ردیف',
          value: 'id',
          sorted: false,
          direction: null,
          sortable: false
        },

        {
          name: 'کد مشتری',
          value: 'customerCode',
          sorted: false,
          direction: null,
          sortable: true
        },
        {
          name: 'نام',
          value: 'customerFirstName',
          sorted: true,
          direction: null,
          sortable: true
        },
        {
          name: 'نام خانوادگی',
          value: 'customerLastName',
          sorted: true,
          direction: null,
          sortable: true
        },
        {
          name: 'نام کاربری',
          value: 'username',
          sorted: true,
          direction: null,
          sortable: false
        },
        {
          name: 'تاریخ ثبت نام',
          value: 'registerDate',
          sorted: false,
          direction: null,
          sortable: true
        },

        {
          name: 'تاریخ آخرین خرید',
          value: 'lastPurchaseDate',
          sorted: true,
          direction: null,
          sortable: true
        },

        {
          name: 'فاصله آخرین خرید تا کنون',
          value: 'distanceLastPurchaseToNow',
          sorted: true,
          direction: null,
          sortable: true
        },
        {
          name: 'تعداد کل خرید',
          value: 'purchaseCount',
          sorted: false,
          direction: null,
          sortable: true
        },

        {
          name: 'فاصله اولین خرید بعد از ثبت نام (روز) ',
          value: 'distanceRegisterToFirstPurchase',
          sorted: false,
          direction: null,
          sortable: true
        },
        {
          name: 'حجم کل خرید',
          value: 'totalAmount',
          sorted: false,
          direction: null,
          sortable: true
        },
        {
          name: ' میانگین فاصله خرید (روز) ',
          value: 'distanceAverage',
          sorted: false,
          direction: null,
          sortable: true
        },
        {
          name: 'میانگین تعداد سطر فاکتور',
          value: 'invoiceItemCountAverage',
          sorted: false,
          direction: null,
          sortable: true
        },
        {
          name: 'نیاز به تماس',
          value: '',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'سوابق تماس',
          value: '',
          sorted: false,
          direction: null,
          sortable: false
        }
      ],
      mobile: '',
      customerUsername: '',
      historyCall: [],
      selectedUser: null,
      mobileUserName: null,
      tablePageNumber: 1,
      lastPurchaseDateMin: '',
      lastPurchaseDateMax: ''
    }
  }

  changeDateMin = (lastPurchaseDateMin) => {
    this.setState({lastPurchaseDateMin})
  }
  changeDateMax = (lastPurchaseDateMax) => {
    this.setState({lastPurchaseDateMax})
  }

  getRfml = (exportStatus) => {
    let filter = this.createFilter(exportStatus)
    this.setState({
      loading: true
    })
    http
      .get(`${REPORT_RETAIL.REPORT_RETAIL_CUSTOMER_RFML}`, {
        params: filter
      })
      .then((response) => {
        if (response.data.error === null) {
          $('.showBaseTable,.print').fadeIn()
          this.setState({
            tablePageNumber: this.state.pageNumber,
            tablePageSize: this.state.pageSize,
            rfml: response.data.object.result,
            countAll: response.data.object.countAll,
            buttonClicked: true,
            loading: false
          })
        } else {
          $('.showBaseTable,.print').fadeOut()
          this.setState({
            rfml: [],
            countAll: 0,
            loading: false
          })
          // message.error(response.data.description)
        }
      })
      .catch(() => {
        this.setState({
          loading: false
        })
      })
  }

  componentDidMount() {
    $(function() {
      $('.filterBtn').on('click', function() {
        $('.basketFilterComponent').slideToggle()
      })
    })

    sessionStorage.setItem('pageNumber', '1')
    sessionStorage.setItem('dropDownVal', '10')
    sessionStorage.setItem('params', '')

    var urlParams = new URLSearchParams(window.location.search)
    var tel = urlParams.get('tel') === null ? '' : urlParams.get('tel')
    if (tel !== '') {
      this.setState(
        {
          customerUsername: tel
        },
        () => {
          this.getRfml(false)
        }
      )
    }
  }

  onResultFetched(data) {
    this.setState({
      rfml: data
    })
  }

  changeDropDown(data) {
    this.setState({
      rfml: data,
      lengthProducts: this.state.countAll
    })
  }

  convertDigit = (string) => {
    return string
      .replace(/[\u0660-\u0669]/g, function(c) {
        return c.charCodeAt(0) - 0x0660
      })
      .replace(/[\u06f0-\u06f9]/g, function(c) {
        return c.charCodeAt(0) - 0x06f0
      })
  }

  handleChangeFromDate = (fromDate) => {
    this.setState({
      fromDate
    })
  }

  handleChangeToDate = (toDate) => {
    this.setState({
      toDate
    })
  }
  createFilter = (exportStatus) => {
    let filter = {}
    let customerCode = this.state.customerCode.toString()
    let customerUsername = this.state.customerUsername.trim()
    let callNecessity = document.getElementById('callNecessity').value
    let {lastPurchaseDateMin, lastPurchaseDateMax} = this.state
    let distanceLastPurchaseToNowMin = document.getElementById('distanceLastPurchaseToNowMin').value
    let distanceLastPurchaseToNowMax = document.getElementById('distanceLastPurchaseToNowMax').value
    let purchaseCountMin = document.getElementById('purchaseCountMin').value
    let purchaseCountMax = document.getElementById('purchaseCountMax').value
    let totalAmountMin = document.getElementById('totalAmountMin').value
    let totalAmountMax = document.getElementById('totalAmountMax').value
    let distanceAverageMin = document.getElementById('distanceAverageMin').value
    let distanceAverageMax = document.getElementById('distanceAverageMax').value
    let invoiceItemCountAverageMin = document.getElementById('invoiceItemCountAverageMin').value
    let invoiceItemCountAverageMax = document.getElementById('invoiceItemCountAverageMax').value

    filter.pageNumber = this.state.pageNumber
    filter.pageSize = this.state.pageSize
    filter.export = exportStatus
    if (this.state.sortBy !== '') {
      filter.sortBy = this.state.sortBy
    }

    if (customerCode !== '') {
      filter.customerCode = customerCode.trim()
    }
    if (customerUsername !== '' && customerUsername.length) {
      filter.customerUsername = customerUsername.trim()
    }
    if (callNecessity !== '') {
      filter.callNecessity = callNecessity
    }
    if (lastPurchaseDateMin !== '') {
      filter.lastPurchaseDateMin = lastPurchaseDateMin
    }
    if (lastPurchaseDateMax !== '') {
      filter.lastPurchaseDateMax = lastPurchaseDateMax
    }
    if (distanceLastPurchaseToNowMin !== '') {
      filter.distanceLastPurchaseToNowMin = distanceLastPurchaseToNowMin
    }
    if (distanceLastPurchaseToNowMax !== '') {
      filter.distanceLastPurchaseToNowMax = distanceLastPurchaseToNowMax
    }
    if (purchaseCountMin !== '') {
      filter.purchaseCountMin = purchaseCountMin
    }
    if (purchaseCountMax !== '') {
      filter.purchaseCountMax = purchaseCountMax
    }
    if (totalAmountMin !== '') {
      filter.totalAmountMin = totalAmountMin
    }
    if (totalAmountMax !== '') {
      filter.totalAmountMax = totalAmountMax
    }
    if (distanceAverageMin !== '') {
      filter.distanceAverageMin = distanceAverageMin
    }
    if (distanceAverageMax !== '') {
      filter.distanceAverageMax = distanceAverageMax
    }
    if (invoiceItemCountAverageMin !== '') {
      filter.invoiceItemCountAverageMin = invoiceItemCountAverageMin
    }
    if (invoiceItemCountAverageMax !== '') {
      filter.invoiceItemCountAverageMax = invoiceItemCountAverageMax
    }

    return filter
  }

  filter() {
    this.setState(
      {
        pageNumber: 1
      },
      () => {
        this.getRfml(false)
      }
    )
  }

  getPrintInfo = () => {
    let filter = this.createFilter(true)
    this.setState({
      loading: true
    })
    http
      .get(`${REPORT_RETAIL.REPORT_RETAIL_CUSTOMER_RFML}`, {
        params: filter
      })
      .then((response) => {
        if (response.data.error == null) {
          sessionStorage.setItem('countAll', response.data.object.countAll)

          this.setState({
            printInfo: response.data.object.result,
            countAll: response.data.object.countAll,
            loading: false
          })

          setTimeout(() => {
            window.print()
          }, 2000)
        } else {
          this.setState({
            printInfo: [],
            loading: false
          })
          // message.error(response.data.description)
        }
        // alert(JSON.stringify(response.data))
      })
      .catch((error) => {
        this.setState({
          loading: false
        })
      })
  }

  exportPrint = () => {
    var css = '@page { size:A4 portrait;}',
      head = document.head || document.getElementsByTagName('head')[0],
      style = document.createElement('style')

    style.type = 'text/css'
    style.media = 'print'

    if (style.styleSheet) {
      style.styleSheet.cssText = css
    } else {
      style.appendChild(document.createTextNode(css))
    }

    head.appendChild(style)
    this.getPrintInfo()
  }

  exportExcel = () => {
    let filter = this.createFilter(true)
    delete filter.export
    this.setState({
      loading: true
    })
    http
      .get(`report/retail/customer/export/rfml`, {
        params: filter
      })
      .then((response) => {
        this.setState({
          loading: false
        })
        if (response.data.error == null) {
          console.log(response.data)

          sessionStorage.setItem('countAll', response.data.object.countAll)
          this.setState({
            excelReport: response.data.object.result
          })
          let {excelReport} = this.state

          for (let i = 0; i < excelReport.length; i++) {
            excelReport[i]['registerDate'] = jMoment(excelReport[i]['registerDate']).format('jYY/jM/jD HH:mm')
            if (excelReport[i]['lastPurchaseDate'] !== null) {
              excelReport[i]['lastPurchaseDate'] = jMoment(excelReport[i]['lastPurchaseDate']).format('jYY/jM/jD HH:mm')
            } else {
              excelReport[i]['lastPurchaseDate'] = ''
            }
            if (excelReport[i]['callNecessity']) {
              excelReport[i]['callNecessity'] = 'دارد'
            } else {
              excelReport[i]['callNecessity'] = 'ندارد'
            }
          }
          this._export.save(this.state.excelReport)
        } else {
          this.setState({
            excelReport: []
          })
        }
      })
      .catch((error) => {
        this.setState({
          loading: false
        })
      })
  }
  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevState.pageNumber !== this.state.pageNumber) {
      this.getRfml(false)
    }
    if (prevState.pageSize !== this.state.pageSize) {
      this.getRfml(false)
    }
    if (prevState.sortBy !== this.state.sortBy) {
      this.getRfml(false)
    }
  }
  getPageNumber = (pageNumber) => {
    this.setState({
      pageNumber
    })
  }

  getPageSize = (pageSize) => {
    this.setState({
      pageSize,
      pageNumber: 1
    })
  }

  getSort = (sortBy) => {
    this.setState({
      sortBy
    })
  }

  getSingleCustomerCode = (customerCode) => {
    this.setState({
      customerCode
    })
  }

  callToCustomer = (mobile) => {
    let internalPhone = '725'
    voip(mobile, internalPhone)
      .then((res) => {})
      .catch((err) => {
        message.error(err)
      })
  }

  historyCall = (customerCode, selectedUser) => {
    let params = {
      relationId: customerCode
    }
    return http
      .get(`notification-logs/relationId`, {
        params
      })
      .then((res) => {
        if (res.data.error === null) {
          this.setState({
            modalHistoryCall: true,
            mobileUserName:
              selectedUser.customer.username === null ? '' : selectedUser.customer.username.replace(/\+98/g, '0'),
            receiverId: customerCode,
            relationId: customerCode,
            historyCall: res.data.object.result === null ? [] : res.data.object.result,
            selectedUser
          })
          return res.data.object.result
        } else {
          message.error(res.data.describtion)
        }
      })
      .catch(() => {})
  }

  sendSms = () => {
    let {receiverId, relationId} = this.state
    let object = {
      notificationType: 'SMS',
      relationId,
      receiverId,
      relationName: 'USER'
    }
    this.setState({
      progressing: true
    })
    http
      .post(`user/profile/${relationId}/assign/sms`, {})
      .then((res) => {
        this.setState({
          progressing: false
        })
        if (res.data.error === null) {
          message.success('با موفقیت ثبت شد')
          this.setState({
            loading: true
          })
          this.historyCall(this.state.receiverId, this.state.selectedUser).then(() => {
            this.setState({
              loading: false
            })
          })
        }
      })
      .catch((err) => {
        this.setState({
          progressing: false
        })
      })
  }

  goCrm = (customreCode) => {
    window.open(`/CRM/list?customerCode=${customreCode}`, '_blank')
  }

  sendCall = () => {
    let {receiverId, relationId} = this.state
    let object = {
      notificationType: 'CALL',
      relationId,
      receiverId,
      relationName: 'USER'
    }
    http
      .post(`notification-logs/create`, object, {})
      .then((res) => {
        if (res.data.error === null) {
          message.success('با موفقیت ثبت شد')

          this.setState({
            loading: true
          })
          this.historyCall(this.state.receiverId, this.state.selectedUser).then(() => {
            window.open(`/CRM/add?customerCode=${this.state.relationId}&fromRfml=true`, '_blank')
            this.setState({
              loading: false
            })
          })
        }
      })
      .catch((err) => {})
  }

  needCall = (distanceAverage, distanceLastPurchaseToNow) => {
    if (distanceAverage >= 1 && distanceAverage <= 7 && distanceLastPurchaseToNow >= 15) {
      return {text: 'دارد', className: 'text-success'}
    } else if (distanceAverage >= 8 && distanceAverage < 14 && distanceLastPurchaseToNow >= 20) {
      return {text: 'دارد', className: 'text-success'}
    } else if (distanceAverage >= 15 && distanceAverage < 21 && distanceLastPurchaseToNow >= 30) {
      return {text: 'دارد', className: 'text-success'}
    } else if (distanceAverage >= 22 && distanceAverage < 30 && distanceLastPurchaseToNow >= 40) {
      return {text: 'دارد', className: 'text-success'}
    } else {
      return {text: 'ندارد', className: 'text-danger'}
    }
  }

  callToCustomer = (mobile, buyerName) => {
    if (mobile === '') {
      message.error('شماره موبایل مورد نظر وجود ندارد')
    } else {
      let internalPhone = '725'
      voip(mobile, buyerName)
        .then((res) => {
          if (res) {
            message.success('تماس برقرار شد لطفا منتظر پاسخ بمانید')
          } else {
            console.log('error')
            this.setState({
              showMobileCallModal: false
            })
          }
        })
        .catch((err) => {
          message.error(err)
          this.setState({
            showMobileCallModal: false
          })
        })
    }
  }

  render() {
    let {pageNumber, pageSize, loading} = this.state

    let name = cookie.load('name')
    let columns = [
      'ردیف',
      'کد مشتری',
      'نام و نام خانوادگی',
      'نام کاربری',
      'تاریخ ثبت نام',
      'تاریخ آخرین خرید',
      'فاصله آخرین خرید تا کنون(روز)',
      'فاصله اولین خرید از ثبت نام تا کنون(روز)',
      'تعداد کل خرید',
      'حجم کل خرید',
      'میانگین فاصله خرید ها',
      'میانگین تعداد سطر فاکتور',
      'نیاز به تماس'
    ]

    return (
      <div className="rtl printA4Page">
        {!this.state.modalHistoryCall && <Loader show={loading} />}
        <div className="printSection">
          <table className="printTable printReportTable" ref={(node) => (this.printPart = node)}>
            <HeaderTablePrint
              header="گزارش سابقه خرید مشتریان"
              headerColSpan={13}
              reporter={name}
              timePrint={jMoment().format('jYYYY/jM/jD HH:mm')}
              leftColSpan={5}
              rightColSpan={5}
              centerColSpan={3}
              centerSection={''}
              rightSection={''}
              columns={columns}
            />
            <tbody>
              {this.state.printInfo.map((rfml, index) => (
                <tr key={'i' + index}>
                  <td>{index + 1}</td>
                  <td>{rfml.customer.userCode}</td>
                  <td>{rfml.customer.name}</td>
                  <td>{rfml.customer.username === null ? '-' : rfml.customer.username.replace(/\+98/g, '0')}</td>
                  <td>{jMoment(rfml.registerDate).format('jYY/jM/jD HH:mm')}</td>
                  <td>
                    {rfml.lastPurchaseDate === null ? '-' : jMoment(rfml.lastPurchaseDate).format('jYY/jM/jD HH:mm')}
                  </td>
                  <td>{rfml.distanceLastPurchaseToNow}</td>
                  <td>{rfml.distanceRegisterToFirstPurchase}</td>
                  <td>{rfml.purchaseCount}</td>
                  <td className="priceCell">{accounting.formatMoney(rfml.totalAmount, '', ',')}</td>
                  <td>{rfml.distanceAverage}</td>
                  <td>{rfml.invoiceItemCountAverage}</td>
                  <td>
                    {rfml.callNecessity ? (
                      <span className="text-dark">دارد</span>
                    ) : (
                      <span className="text-dark">ندارد</span>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="excelSection">
          <ExcelExport
            dir="rtl"
            ref={(exporter) => {
              this._export = exporter
            }}
            fileName={'گزارش سابقه خرید مشتریان : ' + '.xls'}
          >
            <ExcelExportColumn
              key={'userCode'}
              field={'customer.userCode'}
              title={'کد مشتری'}
              width="120"
              footerCellOptions={{wrap: true, textAlign: 'center'}}
            />
            <ExcelExportColumn
              key={'name'}
              field={'customer.name'}
              title={'نام و نام خانوادگی'}
              width="120"
              footerCellOptions={{wrap: true, textAlign: 'center'}}
            />
            <ExcelExportColumn
              key={'customer.name'}
              field={'customer.username'}
              title={'نام کاربری'}
              width="120"
              footerCellOptions={{wrap: true, textAlign: 'center'}}
            />
            <ExcelExportColumn
              key={'registerDate'}
              field={'registerDate'}
              title={'تاریخ ثبت نام'}
              width="120"
              footerCellOptions={{wrap: true, textAlign: 'center'}}
            />
            <ExcelExportColumn
              key={'lastPurchaseDate'}
              field={'lastPurchaseDate'}
              title={'تاریخ آخرین خرید'}
              width="120"
              footerCellOptions={{wrap: true, textAlign: 'center'}}
            />
            <ExcelExportColumn
              key={'distanceLastPurchaseToNow'}
              field={'distanceLastPurchaseToNow'}
              title={'فاصله آخرین خرید تا کنون'}
              width="120"
              footerCellOptions={{wrap: true, textAlign: 'center'}}
            />
            <ExcelExportColumn
              key={'distanceRegisterToFirstPurchase'}
              field={'distanceRegisterToFirstPurchase'}
              title={'فاصله اولین خرید از ثبت نام'}
              width="120"
              footerCellOptions={{wrap: true, textAlign: 'center'}}
            />
            <ExcelExportColumn
              key={'purchaseCount'}
              field={'purchaseCount'}
              title={'تعداد کل خرید'}
              width="120"
              footerCellOptions={{wrap: true, textAlign: 'center'}}
            />
            <ExcelExportColumn
              key={'totalAmount'}
              field={'totalAmount'}
              title={'حجم کل خرید'}
              width="120"
              footerCellOptions={{wrap: true, textAlign: 'center'}}
            />
            <ExcelExportColumn
              key={'distanceAverage'}
              field={'distanceAverage'}
              title={'میانگین فاصله خرید'}
              width="120"
              footerCellOptions={{wrap: true, textAlign: 'center'}}
            />
            <ExcelExportColumn
              key={'invoiceItemCountAverage'}
              field={'invoiceItemCountAverage'}
              title={'میانگین تعداد سطر فاکتور'}
              width="120"
              footerCellOptions={{wrap: true, textAlign: 'center'}}
            />
            <ExcelExportColumn
              key={'callNecessity'}
              field={'callNecessity'}
              title={'نیاز به تماس'}
              footerCellOptions={{wrap: true, textAlign: 'center'}}
            />
          </ExcelExport>
        </div>

        <div className="wrapperIframe">
          <ul className="breadcrumb">
            <li>
              <Link to={'/search'}>به روزرسان</Link>
            </li>
            <li>گزارشات</li>
            <li>گزارش سابقه خرید مشتریان</li>
          </ul>
          <div className="tableComponent">
            <div className="tableTools">
              <div className="tableOptionWrapp">
                <HeaderGrid getPageSize={this.getPageSize} createLink={''} defaultSize="100" enablePageSize />
                <button className="filterBtn">
                  <i className="fa fa-search" />
                </button>
                <button
                  className={'printButton'}
                  disabled={this.state.buttonClicked ? false : true}
                  onClick={this.exportExcel}
                >
                  <i className="fas fa-file-excel" />
                </button>
                <button
                  className="printButton"
                  disabled={this.state.buttonClicked ? false : true}
                  onClick={this.exportPrint}
                >
                  <i className="fas fa-print" />
                </button>
              </div>
            </div>
            <div className="basketFilterComponent">
              <div className="filterInputs">
                <SearchCustomer
                  label={'کد مشتری'}
                  getSingleCustomerCode={this.getSingleCustomerCode}
                  singleResult={true}
                  searchLabel={'جست و جوی مشتری'}
                />

                <div className="formComponent">
                  <label>نام کاربری مشتری:</label>
                  <input
                    type="text"
                    className="form-control"
                    id="customerUsername"
                    name="customerUsername"
                    defaultValue={this.state.customerUsername}
                    onChange={(e) => this.setState({customerUsername: e.target.value})}
                  />
                </div>
                <div className="formComponent">
                  <label>نیاز به تماس:</label>
                  <select className="form-control" id="callNecessity">
                    <option value={''}>------</option>
                    <option selected value={true}>
                      دارد
                    </option>
                    <option value={false}>ندارد</option>
                  </select>
                </div>

                <div className="formComponent">
                  <label>فاصله آخرین خرید تا کنون از</label>
                  <input type="number" className="form-control" id="distanceLastPurchaseToNowMin" />
                </div>

                <div className="formComponent">
                  <label>فاصله آخرین خرید تا کنون تا</label>
                  <input type="number" className="form-control" id="distanceLastPurchaseToNowMax" />
                </div>

                <FromToPicker
                  onChangeFromDate={this.changeDateMin}
                  onChangeToDate={this.changeDateMax}
                  fromLabel="تاریخ آخرین خرید از"
                  toLabel="تاریخ آخرین خرید تا"
                  fromId="from"
                  toId="to"
                />

                <div className="formComponent">
                  <label>تعداد کل خرید از</label>
                  <input type="number" className="form-control" id="purchaseCountMin" />
                </div>

                <div className="formComponent">
                  <label>تعداد کل خرید تا</label>
                  <input type="number" className="form-control" id="purchaseCountMax" />
                </div>

                <div className="formComponent">
                  <label>حجم کل خرید از</label>
                  <input type="number" className="form-control" id="totalAmountMin" />
                </div>

                <div className="formComponent">
                  <label>حجم کل خرید تا</label>
                  <input type="number" className="form-control" id="totalAmountMax" />
                </div>

                <div className="formComponent">
                  <label>میانگین فاصله خرید از (روز)</label>
                  <input type="number" className="form-control" id="distanceAverageMin" />
                </div>

                <div className="formComponent">
                  <label>میانگین فاصله خرید تا (روز)</label>
                  <input type="number" className="form-control" id="distanceAverageMax" />
                </div>

                <div className="formComponent">
                  <label>میانگین تعداد سطر فاکتور از</label>
                  <input type="number" className="form-control" id="invoiceItemCountAverageMin" />
                </div>

                <div className="formComponent">
                  <label>میانگین تعداد سطر فاکتور تا</label>
                  <input type="number" className="form-control" id="invoiceItemCountAverageMax" />
                </div>
              </div>
              <div className="filterOption">
                <button className="confirmFilter" onClick={this.filter.bind(this)}>
                  جست و جو
                </button>
              </div>
            </div>

            <div className="showBaseTable print">
              <table className="baseTable">
                <tbody>
                  <Sort data={this.state.sortData} getSort={this.getSort} />
                  {this.state.rfml.map((rfml, index) => (
                    <tr key={index}>
                      <td>{(this.state.tablePageNumber - 1) * this.state.tablePageSize + index + 1}</td>
                      <td>
                        <Link target="_blank" to={`/club/customer/reportCard?customerCode=${rfml.customer.userCode}`}>
                          {rfml.customer.userCode}
                        </Link>
                      </td>
                      <td>{rfml.customer.firstName}</td>
                      <td>{rfml.customer.lastName}</td>
                      <td>{rfml.customer.username === null ? '-' : rfml.customer.username.replace(/\+98/g, '0')}</td>
                      <td>{jMoment(rfml.registerDate).format('jYY/jM/jD HH:mm')}</td>
                      <td>{jMoment(rfml.lastPurchaseDate).format('jYY/jM/jD HH:mm')}</td>
                      <td>{rfml.distanceLastPurchaseToNow}</td>
                      <td>{rfml.purchaseCount}</td>
                      <td>{rfml.distanceRegisterToFirstPurchase}</td>
                      <td className="priceCell">{accounting.formatMoney(rfml.totalAmount, '', ',')}</td>
                      <td>{rfml.distanceAverage}</td>
                      <td>{rfml.invoiceItemCountAverage}</td>
                      <td className="font-weight-bold">
                        {rfml.callNecessity ? (
                          <span className="text-success">دارد</span>
                        ) : (
                          <span className="text-danger">ندارد</span>
                        )}
                        {/*<span className={this.needCall(rfml.distanceAverage, rfml.distanceLastPurchaseToNow).className}>*/}
                        {/*  {this.needCall(rfml.distanceAverage, rfml.distanceLastPurchaseToNow).text}*/}
                        {/*</span>*/}
                      </td>
                      <td>
                        <button onClick={() => this.historyCall(rfml.customer.userCode, rfml)}>
                          <img src={require('../../image/call.png')} width={20} height={20} />
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <div className="paginationWrapp">
                <Pageing
                  defaultCurrent={1}
                  getPage={this.getPageNumber}
                  pageSize={this.state.pageSize}
                  currentPage={this.state.pageNumber}
                  total={this.state.countAll}
                />
              </div>
            </div>
          </div>
        </div>
        <Modal isOpen={this.state.modalHistoryCall} size="lg" toggle={() => this.setState({modalHistoryCall: false})}>
          <ModalBody>
            <Loader show={this.state.loading} />
            <div className="alert alert-info">
              <div className="my-1" style={{fontSize: '1.3em'}}>
                <strong className="font-weight-bold">سوابق تماس : </strong>
                {this.state.selectedUser !== null && (
                  <span>
                    {this.state.selectedUser.customer.firstName + '  ' + this.state.selectedUser.customer.lastName}
                  </span>
                )}
              </div>
              <div className="my-1" style={{fontSize: '1.3em'}}>
                <strong className="font-weight-bold">کد مشتری : ‌</strong>
                {this.state.selectedUser !== null && <span>{this.state.selectedUser.customer.userCode}</span>}
              </div>
              <div className="my-1" style={{fontSize: '1.3em'}}>
                <strong className="font-weight-bold">موبایل مشتری : </strong>
                {<span>{this.state.mobileUserName}</span>}
              </div>
            </div>
            <div className="d-flex flex-row justify-content-between align-item-center align-content-center">
              <div>
                <button
                  className="btn greenBtn"
                  onClick={() =>
                    this.callToCustomer(
                      this.state.mobileUserName,
                      this.state.selectedUser.customer.firstName + '  ' + this.state.selectedUser.customer.lastName
                    )
                  }
                >
                  <span className="text-white font-weight-bold">تماس با مشتری</span>
                </button>
                <button className="btn btn-info" onClick={() => this.sendCall()}>
                  <span className="text-white font-weight-bold">ثبت تماس تلفنی</span>
                </button>
                <button
                  className="btn orangeBtn text-dark mx-2"
                  disabled={this.state.progressing}
                  onClick={() => this.sendSms()}
                >
                  ارسال پیامک
                </button>
                <button
                  className="btn btn-primary text-dark mx-2"
                  onClick={() => this.goCrm(this.state.selectedUser.customer.userCode)}
                >
                  مشاهده دیدگاه
                </button>
              </div>
              <div>
                <button className="btn redBtn text-white" onClick={() => this.setState({modalHistoryCall: false})}>
                  بستن
                </button>
              </div>
            </div>
            <div className="my-3">
              {this.state.historyCall.length > 0 ? (
                <table className="baseTable">
                  <tbody>
                    <tr>
                      <th>
                        <h5 className="font-weight-bold mb-0">تاریخ ایجاد</h5>
                      </th>
                      <th>
                        <h5 className="font-weight-bold mb-0">اپراتور</h5>
                      </th>
                      <th>
                        <h5 className="font-weight-bold mb-0">نوع تماس</h5>
                      </th>
                    </tr>
                    {this.state.historyCall.map((item, index) => (
                      <tr key={index}>
                        <td>
                          <h5 className="mb-0">
                            {item.created !== null && jMoment(item.created).format('jYYYY/jMM/jDD HH:mm')}
                          </h5>
                        </td>
                        <td>
                          <h5 className="mb-0">{item.operatorInfo.firstName + '  ' + item.operatorInfo.lastName}</h5>
                        </td>
                        <td>
                          <h5 className="mb-0">{item.notificationType === 'CALL' ? 'تماس تلفنی' : 'پیامک'}</h5>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              ) : (
                <h3 className="font-weight-bold text-dark text-center">رکوردی برای نمایش وجود ندارد</h3>
              )}
            </div>
          </ModalBody>
        </Modal>
      </div>
    )
  }
}

export default RfmlReport
